var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNew14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.945312,
    y: 0.186279,
    width: 45.1096,
    height: 45.0959,
    rx: 22.5479,
    fill: "#F6F7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8438 22.6007C13.8438 20.8154 14.1933 19.403 14.8921 18.3635C15.7261 17.1126 16.9241 16.4871 18.4863 16.4871C20.0425 16.4871 21.2376 17.1126 22.0716 18.3635C22.7704 19.403 23.1199 20.8154 23.1199 22.6007C23.1199 24.3919 22.7704 25.8072 22.0716 26.8467C21.2376 28.0976 20.0425 28.723 18.4863 28.723C16.9241 28.723 15.7261 28.0976 14.8921 26.8467C14.1933 25.8072 13.8438 24.3919 13.8438 22.6007ZM15.5969 22.6007C15.5969 24.4095 15.9404 25.6751 16.6275 26.3974C17.115 26.9025 17.7345 27.155 18.4863 27.155C19.238 27.155 19.8575 26.9025 20.345 26.3974C21.0262 25.6809 21.3668 24.4154 21.3668 22.6007C21.3668 20.7919 21.0262 19.5292 20.345 18.8128C19.8575 18.3077 19.238 18.0552 18.4863 18.0552C17.7345 18.0552 17.115 18.3077 16.6275 18.8128C15.9404 19.5351 15.5969 20.7978 15.5969 22.6007ZM24.6615 25.816V23.7811L29.6739 16.7602H32.114V24.1775H34.1137V25.816H32.114V28.45H30.3962V25.816H24.6615ZM26.2823 24.1775H30.3962V18.4516L26.2823 24.1775Z",
    fill: "#0F345A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew14);
export default __webpack_public_path__ + "static/media/new14.0022f3f0e1e45544990183e57854e9d2.svg";
export { ForwardRef as ReactComponent };